
/* DIANAFEMME - BENEFICIOS DEL CARRITO Y REGALO */

(() => {
  if (window.DFControlBeneficios) return;
  window.DFControlBeneficios = true;

  const META = 10000;
  const URL_REGALOS = "/collections/regalos-exclusivos";
  const CLAVE = "df_regalo_visitado_v4";

  const zonas = {
    peninsula: { envio: 5.95, gratis: 50 },
    baleares: { envio: 8.95, gratis: 70 },
    palmas: { envio: 13.95, gratis: 70 },
    tenerife: { envio: 13.95, gratis: 70 },
    portugal: { envio: 8.95, gratis: 70 },
    europa: { envio: 8.95, gratis: 70 },
    ceuta: { envio: 8.95, gratis: null },
    melilla: { envio: 8.95, gratis: null }
  };

  let idsRegalos = null;
  let comprobando = false;
  let temporizador = null;

  const euros = n => n.toLocaleString("es-ES", {
    style: "currency",
    currency: "EUR"
  });

  function obtenerMarca() {
    try {
      return sessionStorage.getItem(CLAVE);
    } catch (_) {
      return null;
    }
  }

  function guardarMarca(valor) {
    try {
      if (valor === null) {
        sessionStorage.removeItem(CLAVE);
      } else {
        sessionStorage.setItem(CLAVE, valor);
      }
    } catch (_) {}
  }

  function cancelarRedireccion() {
    if (temporizador) {
      clearTimeout(temporizador);
      temporizador = null;
    }
  }

  async function obtenerIdsRegalos() {
    if (idsRegalos) return idsRegalos;

    const respuesta = await fetch(
      URL_REGALOS + "/products.json?limit=250",
      { credentials: "same-origin" }
    );

    if (!respuesta.ok) {
      throw new Error("No se puede consultar la colección");
    }

    const datos = await respuesta.json();
    const ids = new Set(
      (datos.products || []).map(p => String(p.id))
    );

    if (!ids.size) {
      throw new Error("No se encontraron productos de regalo");
    }

    idsRegalos = ids;
    return ids;
  }

  function rellenar(id, cantidad) {
    const barra = document.getElementById(id);
    if (!barra) return;

    const porcentaje = Math.max(
      0, Math.min(100, cantidad)
    );

    barra.style.setProperty(
      "width",
      porcentaje.toFixed(2) + "%",
      "important"
    );
  }

  function mostrarMensaje(texto) {
    const mensaje = document.getElementById("df-mensaje");
    if (mensaje) mensaje.textContent = texto;
  }

  function mostrarRegalo(estado, gratis) {
    const caja = document.getElementById("df-regalo-box");
    if (!caja) return;

    if (estado === "elegir") {
      caja.hidden = false;
      caja.style.removeProperty("display");
    } else {
      caja.hidden = true;
      caja.style.setProperty("display", "none", "important");
    }

    let aviso = document.getElementById(
      "df-regalo-confirmado"
    );

    if (!aviso) {
      aviso = document.createElement("div");
      aviso.id = "df-regalo-confirmado";
      aviso.style.cssText =
        "display:none;text-align:center;" +
        "margin:12px 0;padding:15px;" +
        "border:1px solid #EADBD5;" +
        "border-radius:12px;background:#FDF8F6;" +
        "color:#81346E;font-weight:700;" +
        "font-size:13px;line-height:1.5";

      caja.insertAdjacentElement("afterend", aviso);
    }

    if (estado === "seleccionado") {
      aviso.style.display = "block";
      aviso.textContent = gratis
        ? "✓ TU REGALO EXCLUSIVO ESTÁ AÑADIDO GRATIS"
        : "✓ REGALO SELECCIONADO. REVISA SU DESCUENTO";
    } else {
      aviso.style.display = "none";
    }
  }

  async function actualizar() {
    if (comprobando) return;
    if (!document.getElementById("df-beneficios-v3")) return;

    comprobando = true;

    try {
      const base = window.Shopify?.routes?.root || "/";

      // Leer el carrito primero, aunque la colección falle.
      const respuesta = await fetch(base + "cart.js", {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!respuesta.ok) {
        throw new Error("No se pudo consultar el carrito");
      }

      const carrito = await respuesta.json();

      const selector = document.getElementById("df-zona");
      const tarifa = document.getElementById("df-tarifa");
      const zona = zonas[selector?.value];

      let regalos = [];
      let verificacionDisponible = false;

      try {
        const ids = await obtenerIdsRegalos();

        regalos = carrito.items.filter(
          item => ids.has(String(item.product_id))
        );

        verificacionDisponible = true;
      } catch (_) {
        // No asumir que el carrito carece de regalos.
      }

      const seleccionado = regalos.length > 0;

      const gratis = regalos.some(item =>
        item.final_line_price === 0
      );

      const valorRegalos = regalos.reduce(
        (suma, item) => suma + item.final_line_price,
        0
      );

      const totalElegible = Math.max(
        0, carrito.total_price - valorRegalos
      );

      const total = carrito.total_price / 100;
      const cantidad = carrito.item_count;

      // BARRA 1: ENVÍO
      if (zona && zona.gratis !== null) {
        rellenar("df-b1", total / zona.gratis * 100);

        if (tarifa) {
          tarifa.textContent =
            "Envío: " + euros(zona.envio) +
            " · Gratis desde " + euros(zona.gratis) + ".";
        }
      } else {
        rellenar("df-b1", 0);

        if (tarifa) {
          tarifa.textContent = zona
            ? "Envío: " + euros(zona.envio) +
              " · Sin envío gratis configurado."
            : "Selecciona tu destino de envío.";
        }
      }

      // BARRA 2: TERCERA PRENDA
      // Indicativa: cuenta unidades, no elegibilidad.
      rellenar("df-b2", cantidad / 3 * 100);

      // BARRA 3: REGALO
      rellenar("df-b3", totalElegible / META * 100);

      const cumple = totalElegible >= META;

      if (!verificacionDisponible) {
        cancelarRedireccion();
        mostrarRegalo("bloqueado", false);
        mostrarMensaje(
          "No se pudo verificar la selección del regalo."
        );
        return;
      }

      // YA TIENE UN REGALO
      if (seleccionado) {
        cancelarRedireccion();
        guardarMarca("si");

        mostrarRegalo("seleccionado", gratis);

        mostrarMensaje(gratis
          ? "¡Tu regalo exclusivo ya está añadido GRATIS!"
          : "Regalo seleccionado. Comprueba su descuento."
        );
        return;
      }

      // NO ALCANZA 100 €
      if (!cumple) {
        cancelarRedireccion();
        guardarMarca(null);
        mostrarRegalo("bloqueado", false);

        if (
          zona &&
          zona.gratis !== null &&
          total < zona.gratis
        ) {
          mostrarMensaje(
            "Te faltan " +
            euros(zona.gratis - total) +
            " para conseguir tu ENVÍO GRATIS."
          );
        } else if (cantidad < 3) {
          mostrarMensaje(
            "Añade " + (3 - cantidad) +
            " prenda(s) para optar al 15%."
          );
        } else {
          mostrarMensaje(
            "Te faltan " +
            euros((META - totalElegible) / 100) +
            " para tu REGALO EXCLUSIVO."
          );
        }
        return;
      }

      // 100 € ALCANZADOS, SIN REGALO
      mostrarRegalo("elegir", false);

      mostrarMensaje(
        "¡Has alcanzado los 100 € para tu REGALO EXCLUSIVO!"
      );

    } catch (error) {
      cancelarRedireccion();
      mostrarMensaje(
        "No se pudo actualizar el carrito. Inténtalo de nuevo."
      );
    } finally {
      comprobando = false;
    }
  }

  document.addEventListener("change", evento => {
    if (evento.target?.id === "df-zona") {
      actualizar();
    }
  });

  document.addEventListener("cart:updated", actualizar);
  document.addEventListener("cart:refresh", actualizar);
  document.addEventListener("ajaxProduct:added", actualizar);

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) actualizar();
  });

  setInterval(actualizar, 2000);
  actualizar();
})();

/* DIANAFEMME - OCULTAR ETIQUETAS SIN DESCUENTO */

(() => {
  if (window.DFetiquetasRegaloIniciado) return;
  window.DFetiquetasRegaloIniciado = true;

  // Identifica exclusivamente las etiquetas
  // "Regalo exclusivo 100€ (—)"
  // que no tienen ningún importe descontado.

  const etiquetaSinDescuento =
    /^Regalo exclusivo\s*100\s*€\s*\(\s*[—–-]\s*\)$/i;

  let pendiente = false;

  function limpiarEtiquetas() {
    const elementos = document.querySelectorAll(
      "span, small, p, div, li"
    );

    elementos.forEach(elemento => {
      if (elemento.style.display === "none") return;

      const texto = (elemento.textContent || "")
        .replace(/\s+/g, " ")
        .trim();

      if (!etiquetaSinDescuento.test(texto)) return;

      // No ocultar contenedores grandes.
      const hijoCoincidente = Array.from(
        elemento.children
      ).some(hijo =>
        etiquetaSinDescuento.test(
          (hijo.textContent || "")
            .replace(/\s+/g, " ")
            .trim()
        )
      );

      if (hijoCoincidente) return;

      elemento.style.setProperty(
        "display",
        "none",
        "important"
      );
    });
  }

  function programarLimpieza() {
    if (pendiente) return;
    pendiente = true;

    requestAnimationFrame(() => {
      pendiente = false;
      limpiarEtiquetas();
    });
  }

  // Ejecutar al cargar la tienda.
  programarLimpieza();

  // Detectar cambios del carrito Addy.
  const observador = new MutationObserver(
    programarLimpieza
  );

  observador.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener(
    "cart:updated",
    programarLimpieza
  );

  document.addEventListener(
    "cart:refresh",
    programarLimpieza
  );
})();